import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [props: string]: any
}

export const PlayIcon = ({ sx, ...props }: Props) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'white', ...sx }} {...props}>
    <path
      d="M9.35318 3.31573C7.90069 2.39141 6 3.43479 6 5.15644V17.571C6 19.2926 7.90069 20.336 9.35318 19.4117L19.1074 13.2044C20.4547 12.3471 20.4547 10.3803 19.1074 9.52299L9.35318 3.31573Z"
      fill="inherit"
    />
  </SvgIcon>
)

PlayIcon.defaultProps = {
  sx: null,
}
